// All fragrances are sold in one 12ml format.
export const SIZES = [
  { id: '12ml', ml: 12, label: '12ml Oud Oil', price: 30 },
];

export const CURRENCY = 'GBP';
export const CURRENCY_SYMBOL = '£';

export const BRAND = {
  name: "Malik's Aroma",
  location: 'London',
  whatsapp: '447960444563',
  whatsappDisplay: '+44 7960 444563',
  instagram: 'maliksaroma',
  instagramUrl: 'https://www.instagram.com/maliksaroma',
  followers: '75,000+',
};

export const waLink = (msg) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const waProduct = (name, size) =>
  waLink(`Hi Malik's Aroma, I'm interested in ${name} in ${size}. Can you help me order?`);

export const waGeneral = () =>
  waLink(`Hi Malik's Aroma, I'd like help choosing an oud oil.`);
